import { useAppContext, AppContextProvider } from "./AppContext";
import {NotificationContextProvider, useNotificationContext} from "./NotificationContext";
import {UserContextProvider, useUserContext} from "./UserContext";

export { useAppContext, useUserContext};

export const providers = [AppContextProvider, NotificationContextProvider, UserContextProvider];
export const contexts = [useAppContext, useNotificationContext, useUserContext];